//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { darkThemeStyles, rgbToHex } from "../utils/google-maps";

export default {

	name: "hub-geofence-manager",

	props: {

		namespace: {
			required: true,
			type: String
		}

	},

	data()
	{
		return {
			creatorFields: {
				name: "",
				polygon: []
			},
			isCreatingGeofence: false,
			isDrawing: false,
			isLoading: false,
			geofences: [],
			googleMap: null,
			googleMapDrawingManager: null,
			polygon: null,
			selected: 0,
			stagedId: 0,
			theme: "default"
		};
	},

	mounted()
	{
		this.loadGeofences();

		this.theme = document.documentElement.dataset.theme || "default";
	},

	computed: {

		canSave()
		{
			return this.isCreatingGeofence && this.creatorFields.polygon.length >= 3 && this.creatorFields.name.trim().length >= 3;
		},

		selectedGeofence()
		{
			return this.geofences[this.selected] || null;
		}

	},

	methods: {

		createGeofence()
		{
			this.isCreatingGeofence = true;
			this.selected = -1;

			Latte.action.dispatch("latte:tooltip:hide");

			this.$nextTick(() => this.prepareGoogleMapForCreator());
		},

		deleteGeofence()
		{
			Latte.ui.message.confirm(Latte.i18n.translate("hub-geofences", "Delete geofence?"), Latte.i18n.translate("hub-geofences", "Are you sure that you want to delete geofence @0?", [this.selectedGeofence.name])).then(r =>
			{
				if (r.button !== Latte.ui.message.Buttons.OK)
					return;

				const id = this.selectedGeofence.id;

				this.isLoading = true;
				this.selected = -1;

				Latte.api.request(`/api/hub/apps/${this.namespace}/geofences/${id}`, {method: "DELETE"})
					.then(() => this.loadGeofences())
					.catch(err => Latte.core.handleError(err));
			});
		},

		saveGeofence()
		{
			this.isLoading = true;

			let body = JSON.stringify({name: this.creatorFields.name, polygon: this.creatorFields.polygon});

			Latte.api.request(`/api/hub/apps/${this.namespace}/geofences`, {body: body, headers: new Headers({'Content-Type': 'application/json'}), method: "POST"})
				.then(r => r.json())
				.then(r => this.onReceivedSave(r))
				.catch(err => Latte.core.handleError(err));
		},

		selectGeofence(index)
		{
			this.isCreatingGeofence = false;
			this.selected = index;
		},

		cancelDrawing()
		{
			if (this.googleMapDrawingManager === null)
				return;

			this.creatorFields.polygon = [];
			this.isDrawing = false;
			this.googleMapDrawingManager.setDrawingMode(google.maps.drawing.OverlayType.NONE);

			this.$nextTick(() => this.removeDrawing());
		},

		removeDrawing()
		{
			if (this.polygon === null)
				return;

			this.polygon.setMap(null);

			this.creatorFields.polygon = [];
			this.isDrawing = false;
			this.polygon = null;
		},

		startDrawing()
		{
			this.creatorFields.polygon = [];
			this.isDrawing = true;
			this.googleMapDrawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
		},

		loadGeofences()
		{
			this.isCreatingGeofence = false;
			this.isLoading = true;
			this.selected = 0;

			Latte.api.request(`/api/hub/apps/${this.namespace}/geofences?limit=1024`, {cache: "no-cache"})
				.then(r => r.json())
				.then(r => this.onReceivedGeofences(r))
				.catch(err => Latte.core.handleError(err));
		},

		goToCurrentLocation()
		{
			this.isLoading = true;

			navigator.geolocation.getCurrentPosition(p =>
			{
				this.googleMap.panTo(new google.maps.LatLng(p.coords.latitude, p.coords.longitude));
				this.isLoading = false;
			}, err => Latte.core.handleError(err, () => this.isLoading = false));
		},

		prepareGoogleMap()
		{
			this.googleMap = null;
			this.googleMapDrawingManager = null;

			if (this.isCreatingGeofence)
				this.prepareGoogleMapForCreator();
			else if (this.selectedGeofence !== null)
				this.prepareGoogleMapForGeofence();
		},

		prepareGoogleMapForCreator()
		{
			const rgb = window.getComputedStyle(this.$el).getPropertyValue("--color-primary").split(",").map(i => parseInt(i));
			const hex = rgbToHex(...rgb);

			const mapOptions = {
				center: new google.maps.LatLng(52.0423968, 6.6174228),
				zoom: 16,
				fullscreenControl: false,
				mapTypeControl: false,
				rotateControl: false,
				streetViewControl: false
			};

			if (this.theme === "dark")
				mapOptions.styles = darkThemeStyles;

			const drawingOptions = {
				drawingMode: google.maps.drawing.OverlayType.NONE,
				drawingControl: false,
				drawingControlOptions: {
					position: google.maps.ControlPosition.TOP_CENTER,
					drawingModes: ['polygon']
				},
				polygonOptions: {
					editable: true,
					strokeColor: hex,
					strokeOpacity: 0.75,
					strokeWeight: 2,
					fillColor: hex,
					fillOpacity: 0.35
				}
			};

			this.googleMap = new google.maps.Map(this.$el.querySelector("#google-map"), mapOptions);
			this.googleMapDrawingManager = new google.maps.drawing.DrawingManager(drawingOptions);
			this.googleMapDrawingManager.setMap(this.googleMap);

			google.maps.event.addListener(this.googleMapDrawingManager, 'polygoncomplete', this.onPolygonComplete);
		},

		prepareGoogleMapForGeofence()
		{
			const bounds = new google.maps.LatLngBounds();
			const points = [];
			const rgb = window.getComputedStyle(this.$el).getPropertyValue("--color-primary").split(",").map(i => parseInt(i));
			const hex = rgbToHex(...rgb);

			for (let coords of this.selectedGeofence.polygon.coordinates[0])
			{
				bounds.extend(new google.maps.LatLng(coords[0], coords[1]));
				points.push({lat: coords[0], lng: coords[1]});
			}

			const polygon = new google.maps.Polygon({
				paths: points,
				strokeColor: hex,
				strokeOpacity: 0.75,
				strokeWeight: 2,
				fillColor: hex,
				fillOpacity: 0.35
			});

			const mapOptions = {
				center: bounds.getCenter(),
				fullscreenControl: false,
				mapTypeControl: false,
				rotateControl: false,
				streetViewControl: false
			};

			if (this.theme === "dark")
				mapOptions.styles = darkThemeStyles;

			this.googleMap = new google.maps.Map(this.$el.querySelector("#google-map"), mapOptions);

			polygon.setMap(this.googleMap);
			this.googleMap.fitBounds(bounds);
		},

		removeGoogleMap()
		{
			if (this.$el.querySelector("#google-map") !== null)
				this.$el.querySelector("#google-map").innerHTML = "";
		},

		onPolygonComplete(polygon)
		{
			this.googleMapDrawingManager.setDrawingMode(google.maps.drawing.OverlayType.NONE);
			this.isDrawing = false;
			this.polygon = polygon;

			google.maps.event.addListener(this.polygon.getPath(), 'insert_at', () => this.onPolygonUpdate());
			google.maps.event.addListener(this.polygon.getPath(), 'remove_at', () => this.onPolygonUpdate());
			google.maps.event.addListener(this.polygon.getPath(), 'set_at', () => this.onPolygonUpdate());
		},

		onPolygonUpdate()
		{
			const data = [];

			const positions = this.polygon.getPath().getArray();

			for (let pos of positions)
				data.push([pos.lat(), pos.lng()]);

			this.creatorFields.polygon = data;
		},

		onReceivedGeofences(response)
		{
			this.geofences = response.data;
			this.isLoading = false;

			if (this.stagedId > 0)
			{
				this.selected = this.geofences.findIndex(g => g.id === this.stagedId) || 0;
				this.stagedId = 0;
			}

			this.$nextTick(() => this.prepareGoogleMap());
		},

		onReceivedSave(response)
		{
			this.isCreatingGeofence = false;
			this.isLoading = false;
			this.stagedId = response.data;

			this.loadGeofences();
		}

	},

	watch: {

		isCreatingGeofence()
		{
			this.cancelDrawing();
			this.removeDrawing();

			this.creatorFields.name = "";
			this.creatorFields.polygon = [];
		},

		polygon()
		{
			if (this.polygon === null)
				return;

			this.onPolygonUpdate();
		},

		selectedGeofence()
		{
			this.removeGoogleMap();

			if (this.selectedGeofence !== null)
				this.$nextTick(() => this.prepareGoogleMap());
		}

	}

}

